export default __webpack_public_path__ + "static/media/guide_dev_07.7734c9a7.md";